import React from "react";
import { useI18n } from '../context/I18nContext';

const LogPanel = ({ logs, onClear, title }) => {
  const { t } = useI18n();
  const tituloPainel = title || t("log.title");
  return (
    <div className="bg-gray-900 rounded-2xl shadow-sm border border-gray-800 h-full flex flex-col">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-800">
        <h3 className="text-sm font-semibold text-white flex items-center gap-2">
          <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
          {tituloPainel}
        </h3>
        <button
          onClick={onClear}
          className="text-xs text-gray-400 hover:text-white transition-colors"
        >
          Limpar
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-2 max-h-[700px] font-mono text-xs">
        {logs.length === 0 ? (
          <div className="text-gray-500 text-center py-8">{t('logpanel.j1')}</div>
        ) : (
          logs.map((log) => (
            <div key={log.id} className={log.type === "request" ? "flex flex-col gap-1" : "flex gap-2"}>
              <div className="flex gap-2">
                <span className="text-gray-500 flex-shrink-0">[{log.timestamp}]</span>
                <span className={
                  log.type === "success" ? "text-green-400" :
                  log.type === "error" ? "text-red-400" :
                  log.type === "warning" ? "text-yellow-400" :
                  log.type === "request" ? "text-purple-400" :
                  "text-blue-400"
                }>
                  {log.type === "success" && "\u2713 "}
                  {log.type === "error" && "\u2717 "}
                  {log.type === "warning" && "\u26A0 "}
                  {log.type === "info" && "\u2192 "}
                  {log.type === "request" && "\u2B06 "}
                  {log.text}
                </span>
              </div>
              {log.details && (
                <pre className="ml-4 mt-1 p-2 bg-gray-800 rounded text-gray-300 text-xs overflow-x-auto whitespace-pre-wrap">
                  {log.details}
                </pre>
              )}
            </div>
          ))
        )}
      </div>
      <div className="px-4 py-2 border-t border-gray-800 text-xs text-gray-500">
        {logs.length} {logs.length === 1 ? t('log.entryOne') : t('log.entryMany')}
      </div>
    </div>
  );
};

export default LogPanel;
